<template>
  <div class="mdl-layout__drawer mdl-color--grey-50 mdl-color-text--grey-800">
    <header class="drawer-header bg-green">
      <img :src="$user.data.avatar || './profile-64.png'" class="drawer-avatar">
      <div class="drawer-avatar-dropdown">
        <strong>{{ $user.data.email }}</strong>
        <small>{{ $user.data.role.toUpperCase() }}</small>
        <div class="mdl-layout-spacer"></div>
      </div>
    </header>
    <nav class="drawer-navigation mdl-navigation mdl-color--grey-50 mdl-color-text--grey-800">
      <router-link v-for="link in links" :to="link.to" :key="link.to">
        <a class="mdl-navigation__link" @click="toggleDrawer">
          <i class="material-icons" role="presentation">{{ link.icon }}</i>
          {{ link.name }}
        </a>
      </router-link>
      <a class="mdl-navigation__link">
        <button class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored"
          style="width: 100%"
          @click="signOut">Cerrar Sesión</button>
      </a>
    </nav>
  </div>
</template>

<script>
export default {
  data () {
    return {
      links: []
    }
  },
  methods: {
    toggleDrawer () {
      document.querySelector('.mdl-layout').MaterialLayout.toggleDrawer()
    },
    signOut () {
      let auth2 = gapi.auth2.getAuthInstance()
      auth2.signOut().then(() => {
        this.$idb.keyVal.clear('login').then(() => {
          window.location.reload()
        })
      })

      this.$loading.show()
    }
  },
  mounted () {
    const self = this
    switch (this.$user.data.roleCode) {
      case 'auditor':
        this.links = [
          { to: '/', icon: 'dvr', name: 'Newsfeed' },
          { to: '/auditoria', icon: 'place', name: 'Auditoría' },
          { to: '/mi-perfil', icon: 'people', name: 'Perfil' }
        ]
      break;
      case 'jefe':
        this.links = [
          { to: '/', icon: 'dvr', name: 'Newsfeed' },
          { to: '/mi-perfil', icon: 'people', name: 'Perfil' }
        ]
      break;

      case 'mantenimiento':
        this.links = [
          { to: '/', icon: 'dvr', name: 'Newsfeed' },
          { to: '/mi-perfil', icon: 'people', name: 'Perfil' }
        ]
      break;
    }

    gapi.load('auth2', function() {
      gapi.auth2.init().then(googleAuth => {
        const googleUser = googleAuth.currentUser.get(),
              authResponse = googleUser.getAuthResponse(),
              idToken = authResponse.id_token,
              isNewToken = self.$user.data.idToken !== idToken

        if (isNewToken) {
          self.$user.data.idToken = idToken
          return self.$idb.keyVal.set('login', undefined, self.$user.data)
        }
      })
    })

    componentHandler.upgradeElement(this.$el)
  }
}
</script>

<style lang="css" scoped>
  .drawer-header {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    padding: 16px;
    height: 151px;
    color: #fff;
  }

  .drawer-avatar {
    width: 48px;
    /*height: 48px;*/
    margin-right: 1rem;
    border-radius: 24px;
    border: 2px solid #fff;
  }

  .drawer-avatar-dropdown {
    display: flex;
    position: relative;
    flex-direction: column;
    width: 100%;
  }

  .drawer-navigation {
    z-index: -2;
  }

  .drawer-navigation a {
    text-decoration: none;
  }

  .drawer-navigation .mdl-navigation__link {
    font-weight: 700;
  }

  .drawer-navigation .mdl-navigation__link .material-icons {
    font-size: 24px;
    margin-right: 32px;
    margin-bottom: 2px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?75946074